module.exports = __webpack_public_path__ + "porownanie1.png?5924910db91a87533964be483c2620d0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/porownanie1.png
// module id = 19
// module chunks = 0